module.exports = __webpack_public_path__ + "static/img/planLeft2.32c9fbc1.png";